module.exports = __webpack_public_path__ + "img/thin-plus.44f06e46.svg";